import React, { Fragment } from "react";
import { Layout } from "../../components/common";
import ProductBanner from "../../components/ProductBanner";
import Carousel from '../Carousel';
import { CarouselContainer } from '../Carousel/Component';
import ProductFeedback from '../ProductFeedback';
import MetaData from '../common/meta/MetaData';
import { Image, ImageContainer } from '../common/ui/Image'
import Heading from "../common/ui/Heading";
import CutomButton from "../common/ui/CutomButton";
import ProductCard from "./../ProductCard";
import { ProductCardContainer } from "./../ProductCard/Components";
import ProductList from "./../ProductList";
import { ProductListWrapper, ProductListContainer } from "./../ProductList/Component";
import { Row, Col } from "react-flexa";
import Blog from '../../components/Blog'
import { onButtonClick } from '../../utils/helpers';
import CustomCarousel from '../../components/common/CustomCarousel'

const ProductDetailsLayout = ({ data, location, title, description, featuredBlogArticles=[] }) => {
    // [@INFO] Children can be positioned anywhere in the layout

    let { meta, banner, curve, testimonial, productList, stepsCarousel, productFeedback, productCard, blogSectionMeta } = data;

    let products = {};
    if(productList){
        products = {
            ...productList,
            heading:productList.heading,
            // [@INFO:] - Below logic will only work if pathname is /khata and not work if pathname is /product/khata
            productLists:productList.productLists.filter(el => el.link.split("/")[1].toLowerCase() !== location.pathname.split("/")[1])
        }
    }
    
    return (
        <Fragment>
            <MetaData
                data={{}}
                title={title}
                description={description}
                keywords={meta?.keywords}
                location={location}
                type="website"
            />
            <Layout>
                <Row
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                >
                    {banner && products && <ProductBanner bannerData={banner} productsList={products}/>}
                    {
                        stepsCarousel && <CarouselContainer
                            borderRadiusBottomLeft="50% 15%"
                            sBorderRadiusBottomLeft="50% 5%"
                            borderRadiusBottomRight="50% 15%"
                            sBorderRadiusBottomRight="50% 5%"
                            background={`url(${stepsCarousel.firstImageSrc}) no-repeat left center, url(${stepsCarousel.secondImageSrc}) no-repeat right top, url(${stepsCarousel.thirdImageSrc}) no-repeat left bottom #48a3ed`}
                            backgroundAfter={`url(${stepsCarousel.firstImageSrc}) right bottom no-repeat`}
                            sBackground="#48a3ed"
                            padding="30px 0px"
                        >
                            <Heading
                                size="sm"
                                weight="normal"
                                align="center"
                                color="WHITE"
                                margin="25px auto 40px"
                                sMargin="5px auto 41px"
                                lineHeight="1.13"
                                padding='0 1.5% 0 0'
                            >
                                {stepsCarousel.heading}
                            </Heading>
                            <CustomCarousel
                                width='18vw'
                                padding='0 2vw 0 0'
                                sWidth='50vw'
                            >
                                {
                                    stepsCarousel.carouselSlides &&
                                    stepsCarousel.carouselSlides instanceof Array &&
                                    stepsCarousel.carouselSlides.map((item, i) => {
                                        return (
                                            <ImageContainer key={i} maxWidth='250px'>
                                                <Image {...item} />
                                            </ImageContainer>
                                        );
                                    })
                                }

                            </CustomCarousel>
                            <CutomButton
                                left='-10px'
                                size="md"
                                weight="bold"
                                height="45px"
                                margin="30px auto -45px"
                                padding="1px 15px 0px"
                                width="max-content"
                                minwidth="230px"
                                sdisplay="none"
                                boxshadow="0 4px 8px 1px rgba(0, 0, 0, 0.08)"
                                onClick={onButtonClick.bind(null, stepsCarousel.link, stepsCarousel.external)}
                            >
                                {stepsCarousel.downloadAppLinkDesktopView.content}
                                {stepsCarousel.downloadAppLinkDesktopView.androidImgSrc && <ImageContainer
                                    width='13px'
                                    margin="-4px 5px 0px"
                                >
                                    <Image
                                        src={`${stepsCarousel.downloadAppLinkDesktopView.androidImgSrc}`}
                                    />
                                </ImageContainer>}
                                {stepsCarousel.downloadAppLinkDesktopView.iosImgSrc && <ImageContainer
                                    width='13px'
                                    margin="-4px 5px 0px"
                                >
                                    <Image
                                        src={`${stepsCarousel.downloadAppLinkDesktopView.iosImgSrc}`}
                                    />
                                </ImageContainer>}
                            </CutomButton>
                        </CarouselContainer>
                    }
                    {curve.curveDesign && <ImageContainer
                        textAlign="right"
                        margin="-8% 0px 0px auto"
                        width="50%"
                    >
                        <Image
                            src={`${curve.curveDesign.imgSrc}`}
                            width="100%"
                        />
                    </ImageContainer>}
                    {productCard && <ProductCardContainer
                        background={`url(${productCard.firstImgSrc}) no-repeat bottom right`}
                        backgroundSize="auto"
                        sBackground={`url(${productCard.secondImgSrc}) no-repeat 100% 15%, url(${productCard.thirdImgSrc}) no-repeat 0% 80%`}
                        sBackgroundSize="auto,auto"
                        backgroundBefore={`url(${productCard.fourthImgSrc}) no-repeat 0% 50%`}
                    >
                        <Row
                            display={{ xs: "flex", md: "flex", lg: "inline-flex" }}
                            flexDirection="column"
                            gutter="10px"
                        >
                            <Heading
                                size="sm"
                                weight="normal"
                                align="center"
                                color="MEDIUM_BLACK"
                                margin="0px 0px 0px"
                                sMargin="0px 0px 0px"
                                padding="2px"
                            >
                                {" "}
                                {productCard.heading}
                            </Heading>
                            <Col
                                lg={10}
                                style={{ margin: "0 auto", padding: "20px 0px 30px" }}
                            >
                                <ProductCard
                                    cardStyle={{
                                        maxWidth: "555px",
                                        width: "38vw",
                                        padding: "25px 30px",
                                        sPadding: "17px 10px",
                                        margin: "10px",
                                        sWidth: "90vw",
                                        sMargin: '5px 10px'
                                    }}
                                    iconStyle={{
                                        width: "36px",
                                        height: "46px",
                                        sWidth: "23px",
                                        sHeight: "30px"
                                    }}
                                    headingStyle={{
                                        size: "xxxs",
                                        weight: "normal",
                                        sMargin: "unset",
                                        padding: "20px 0px 0px",
                                        sPadding: "10px 0px 10px",
                                        lineHeight: "0.8",
                                        letterSpacing: "-0.11px",
                                        color: "CHQBOOK_BLUE"
                                    }}
                                    textStyle={{
                                        size: "md",
                                        lineHeight: "1.38",
                                        margin: "14px 0px 0px",
                                        color: "LIGHTER_GREY",
                                        sMargin: "0px"
                                    }}
                                    data={productCard.productCards}
                                />
                            </Col>
                        </Row>
                    </ProductCardContainer>}
                    {productFeedback && <ProductFeedback
                        feedbackData={productFeedback}
                    />}
                    {products && <ProductListContainer>
                        <Heading
                            size="sm"
                            weight="normal"
                            align="center"
                            color="MEDIUM_BLACK"
                            margin="20px 0px"
                        >
                            {" "}
                            {products.heading}{" "}
                        </Heading>
                        <ProductListWrapper>
                            <ProductList
                                textstyle={{
                                    margin: "0px",
                                    padding: "15px 0px 0px",
                                    size: "lg",
                                    weight: "normal",
                                    height: '100%'
                                }}
                                listcard={{
                                    border: "1px solid rgba(128, 128, 128, 0.1)",
                                    height: "100%",
                                    padding: "15px",
                                    sPadding: "10px",
                                    align: "center",
                                    width: "201px",
                                    minHeight: "106px",
                                    sWidth: "106px",
                                    sMinHeight: '110px'
                                }}
                                data={products.productLists}
                            />
                        </ProductListWrapper>
                    </ProductListContainer>}
                    {testimonial && <CarouselContainer
                        background={`#48a3ed url(${testimonial.imgSrc}) no-repeat`}
                        padding="50px 40px"
                    >
                        <Heading
                            size="sm"
                            weight="normal"
                            align="center"
                            color="WHITE"
                            margin="15px auto 35px"
                            sMargin="15px auto 35px"
                        >
                            {testimonial.heading}
                        </Heading>
                        <Carousel
                            slides={testimonial.slidesData}
                            navigation={true}
                            opacity="0.7"
                            boxShadow="0 7px 14px 1px rgba(0, 0, 0, 0.08)"
                            itemWidth="95%"
                            xsspacebetweenslides={20}
                            sspacebetweenslides={20}
                            mspacebetweenslides={20}
                            lspacebetweenslides={70}
                            xlspacebetweenslides={70}
                            xsSlidesPerView={1}
                            sSlidesPerView={1.5}
                            mSlidesPerView={2.5}
                            lSlidesPerView={3.5}
                            xlSlidesPerView={4}
                            xxlSlidesPerView={5}
                            backgroundImage={false}
                        />
                    </CarouselContainer>}
                    {featuredBlogArticles &&
                        featuredBlogArticles.length != 0 &&
                        <Blog blog={{
                            meta: blogSectionMeta,
                            blogs:featuredBlogArticles
                        }} />
                    }
                </Row>
            </Layout>
        </Fragment>
    );
};

export default ProductDetailsLayout;
